<template>
  <div
    class="create-edit-content-box"
    @click="removeHighlight"
    :class="{
      [`create-edit-content-box--${createRenderType}`]: true,
      'create-edit--open':
        props.renderType == 'create'
          ? create_createEditOpenState == 'max' || create_createEditOpenState == 'playermax'
          : nocreate_createEditOpenState == 'max' || nocreate_createEditOpenState == 'playermax',
      'create-edit--min':
        props.renderType == 'create'
          ? create_createEditOpenState == 'min'
          : nocreate_createEditOpenState == 'min',
      'create-edit--playerMin':
        props.renderType == 'create'
          ? create_createEditOpenState == 'playermin'
          : nocreate_createEditOpenState == 'playermin',
    }"
  >
    <div
      class="create-edit"
      :class="{
        'create-edit--easy': renderData.createEditMode == 'easy',
        'create-edit--hard': renderData.createEditMode == 'hard',
      }"
    >
      <div
        class="create-edit-content flex"
        :style="{
          height: createRenderType == 'mobile' ? '100%' : '100%',
        }"
      >
        <div class="create-mode-switch-box flex-row-center">
          <ModeSwitch :isSimilar="!!props.similarData"></ModeSwitch>
          <div class="model-box">
            <PersonalModel></PersonalModel>
          </div>
          <div class="create-edit-title-close" @click.stop>
            <IconButton
              v-if="renderData.linkurl != ''"
              size="40px"
              icoSize="20px"
              :disable="props.disableClose"
              backgroundColor="rgb(255, 255, 255, 0.1)"
              hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
              @onClick="closeCreateEdit"
            >
              <img src="@/assets/img/close-ico.png" />
            </IconButton>
          </div>
        </div>

        <div class="create-edit-box height-0 flex flex1" ref="refCreateEditAdvance">
          <div class="create-edit-title flex">
            <div class="create-edit-title-label flex1">
              <!-- <span v-if="createRenderType == 'pc'">{{
                $$t("create.create_title")
              }}</span> -->
            </div>
          </div>
          <div class="create-edit-area height-0 flex1 flex">
            <div class="create-edit-lyric flex1" ref="refCreateEditLyric">
              <h2 class="create-title">{{ $$t("create.lyric") }}</h2>
              <div class="create-edit-lyric-area">
                <Lyric
                  ref="refEditLyric"
                  v-if="renderData.ifRender"
                  :similarData="props.similarData"
                ></Lyric>
              </div>
            </div>
            <div class="create-edit-easy flex1">
              <CreateEditEasy :similarData="props.similarData"></CreateEditEasy>
            </div>
            <div class="create-edit-muse">
              <h2 class="create-title">{{ $$t("create.muse") }}</h2>
              <div
                class="create-edit-muse-area"
                ref="refCreateEditMuse"
                :class="{
                  'create-edit-muse-area--disabled': !userDataStore.isLogin,
                  [`create-edit-muse-${renderData.curHighlightRefer}`]:
                    renderData.curHighlightRefer,
                }"
              >
                <div
                  class="reference-item reference-item-refer"
                  :class="{
                    'reference-item--highlight': renderData.curHighlightRefer == 'refer',
                    'reference-item--greydown':
                      (renderData.curHighlightRefer && renderData.curHighlightRefer != 'refer') ||
                      (!renderData.curHighlightRefer &&
                        renderData.vocalCornerMarkReferHighlight &&
                        userDataStore.isLogin),
                  }"
                >
                  <ReferenceEditItem
                    key="refer"
                    type="refer"
                    audioUrlSuffix="?type=muse_refer"
                    :similarData="props.similarData"
                    :lock="props.similarData?.refer?.is_subscription_privilege"
                  ></ReferenceEditItem>
                </div>
                <div
                  class="reference-item reference-item-vocal"
                  :class="{
                    'reference-item--highlight': renderData.curHighlightRefer == 'vocal',
                    'reference-item--greydown':
                      renderData.curHighlightRefer && renderData.curHighlightRefer != 'vocal',
                    'reference-item--highlight-new':
                      !renderData.curHighlightRefer &&
                      renderData.vocalCornerMarkReferHighlight &&
                      userDataStore.isLogin,

                    'reference-item--highlight-new-highlight':
                      renderData.curHighlightRefer != 'vocal' &&
                      renderData.vocalCornerMarkReferHighlight &&
                      userDataStore.isLogin,
                    'reference-item--highlight-new-highlight-cur':
                      renderData.curHighlightRefer == 'vocal' &&
                      renderData.vocalCornerMarkReferHighlight &&
                      userDataStore.isLogin,
                  }"
                >
                  <ReferenceEditItem
                    key="vocal"
                    type="vocal"
                    audioUrlSuffix="?type=muse_vocal"
                    :similarData="props.similarData"
                    :lock="props.similarData?.vocal?.is_subscription_privilege"
                  ></ReferenceEditItem>
                </div>
                <div
                  class="reference-item reference-item-prompt"
                  :class="{
                    'reference-item--highlight': renderData.curHighlightRefer == 'prompt',
                    'reference-item--greydown':
                      (renderData.curHighlightRefer && renderData.curHighlightRefer != 'prompt') ||
                      (!renderData.curHighlightRefer &&
                        renderData.vocalCornerMarkReferHighlight &&
                        userDataStore.isLogin),
                  }"
                >
                  <ReferenceEditItem
                    key="prompt"
                    type="prompt"
                    :similarData="props.similarData"
                  ></ReferenceEditItem>
                </div>
                <div
                  class="reference-item reference-item-motif"
                  :class="{
                    'reference-item--highlight': renderData.curHighlightRefer == 'motif',
                    'reference-item--greydown':
                      (renderData.curHighlightRefer && renderData.curHighlightRefer != 'motif') ||
                      (!renderData.curHighlightRefer &&
                        renderData.vocalCornerMarkReferHighlight &&
                        userDataStore.isLogin),
                  }"
                >
                  <ReferenceEditItem
                    key="motif"
                    type="motif"
                    audioUrlSuffix="?type=muse_motif"
                    :similarData="props.similarData"
                    :lock="props.similarData?.motif?.is_subscription_privilege"
                  ></ReferenceEditItem>
                </div>
                <!-- <div
                  class="reference-item reference-item-text tc reference-item-feature omlh-2"
                >
                  {{ $$t("create.more_features") }}
                </div> -->
              </div>
              <!-- <div class="create-edit-muse-area-mask" v-if="!isLogin"></div> -->
            </div>
          </div>
          <div class="create-submit tc pointer" v-if="!props.similarData">
            <div
              v-if="createRenderType == 'pc' && userDataStore.isShowReturenReward"
              class="reward-popup"
            >
              <span>Congrats on your return reward!</span>
              <img src="@/assets/img/close-dark-ico.png" alt="" @click="changeRewardsShowState" />
            </div>
            <div
              class="create-submit-credits fn-inline"
              @click="
                () => {
                  if (!modelDataStore.current_model?.free_to_use && createRenderType != 'mobile') {
                    goBuyCredits()
                  }
                }
              "
            >
              <!-- <i class="create-submit-credits-ico credits-ico fn-inline"></i> -->
              <div
                class="create-submit-button-model-use-first-label fn-inline"
                v-if="
                  (modelDataStore.current_model?.free_to_use ?? 0) && createRenderType != 'mobile'
                "
              >
                {{ $$t("create.first_free") }}
              </div>
              <span class="create-submit-credits-text fn-inline" v-else>
                {{ $$t("create.credits_remaining") }}
                {{ renderData.userCredits }}
              </span>

              <!-- <i class="create-submit-credits-ico arrow-ico fn-inline"></i> -->
            </div>

            <div
              ref="refCreateSubmitButton"
              class="create-submit-button fn-inline create-submit-button-disabled"
              :class="{
                'driver-high-breathe':
                  !userDataStore.isLogin && curDriverKey == 'click_to_generate_song--not',
              }"
            >
              <div
                class="create-by-ai-tip"
                style="margin-bottom: 10px"
                v-if="
                  createRenderType == 'mobile' &&
                  globalConfig.appname == chinaAppName &&
                  renderData.createEditMode == 'hard'
                "
              >
                {{ $$t("editor.create_ai_identification") }}
              </div>
              <Bubble
                :disabled="!renderData.disabled"
                :content="$$t('create.min_letters_lyric')"
                placement="top"
              >
                <Button
                  v-if="createRenderType != 'mobile'"
                  :disabled="
                    renderData.disabled &&
                    !(
                      createEditGuidTourVisible &&
                      createEditGuidTourControlVisible &&
                      createEditMode == 'hard'
                    )
                  "
                  @click="
                    () => {
                      doGernerate()
                    }
                  "
                  :loading="renderData.isLoading"
                  :renderStyle="{
                    '--padding': '0',
                    '--width': '100%',
                    '--height': '48px',
                    '--borderRadius': '48px',
                    '--background':
                      'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
                    '--fontColor': '#000',
                    '--fontSize': '20px',
                    '--fontWeight': '700',
                    '--border': 'none',
                    '--backgroundHover':
                      'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
                    '--fontColorHover': '#000',
                  }"
                >
                  <div class="flex-center btn-content">
                    <span>{{ $$t("create.create") }}</span>
                    <div
                      class="create-submit-button-model-use-first fn-inline"
                      v-if="
                        (modelDataStore.current_model?.free_to_use ?? 0) &&
                        createRenderType == 'mobile'
                      "
                    >
                      {{ $$t("create.first_free") }}
                    </div>
                  </div>
                </Button>

                <Button
                  v-if="createRenderType == 'mobile'"
                  @click="
                    () => {
                      doGernerate()
                    }
                  "
                  :disabled="
                    renderData.disabled &&
                    !(
                      createEditGuidTourVisible &&
                      createEditGuidTourControlVisible &&
                      createEditMode == 'hard'
                    )
                  "
                  :loading="renderData.isLoading"
                  :renderStyle="{
                    '--padding': '0',
                    '--width': '100%',
                    '--height': '48px',
                    '--borderRadius': '48px',
                    '--background':
                      'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
                    '--fontColor': '#fff',
                    '--fontSize': '20px',
                    '--fontWeight': '700',
                    '--border': 'none',
                    '--backgroundHover':
                      'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
                    '--fontColorHover': '#fff',
                  }"
                >
                  <div class="flex-center btn-content">
                    <span class="ico fn-inline"></span>
                    <span class="fn-inline">{{ $$t("create.create") }}</span>
                    <div
                      class="create-submit-button-model-use-first fn-inline"
                      v-if="
                        (modelDataStore.current_model?.free_to_use ?? 0) &&
                        createRenderType == 'mobile'
                      "
                    >
                      {{ $$t("create.first_free") }}
                    </div>
                  </div>
                </Button>
              </Bubble>

              <div
                class="driver-high-bounce"
                v-if="curDriverKey == 'click_to_generate_song--not' && !renderData.disabled"
              >
                {{ $$t("create.click_to_generate_song") }}
              </div>
            </div>
          </div>
          <div
            class="create-ai-identification"
            v-if="
              createRenderType == 'pc' &&
              globalConfig.appname == chinaAppName &&
              renderData.createEditMode == 'hard'
            "
          >
            {{ $$t("editor.create_ai_identification") }}
          </div>
        </div>
      </div>
      <createGuidTour
        v-if="renderData.refElList?.length"
        :refElList="renderData.refElList"
      ></createGuidTour>
      <div class="create-min-button-box" v-if="!globalPlayerOpened && false">
        <!-- <div class="create-min-button-player-box flex" >
        <div class="create-min-button-player-player flex1"></div>
        <div
          class="create-min-button-player-button flex-center"
          @click="openCreateEdit"
        >
          <i class="block"></i>
        </div>
      </div> -->
        <div class="create-min-button" @click="openCreateEdit">
          <i class="fn-inline"></i>
          <span class="fn-inline"> {{ $$t("create.create") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { useRouter, useRoute } from "vue-router"
import { storeToRefs } from "pinia"

import globalConfig, { ModuleOpenStateControl, chinaAppName } from "@/config/config.js"
import tools from "@/utils/tools.js"

import feedListApi from "@/api/api/feedListApi.js"

import Lyric from "./editLyric/lyric.vue"
import PersonalModel from "./personalModel/index.vue"
import ReferenceEditItem from "./referenceEditItem.vue"
import GenerateResult from "./feedList/generateResult.vue"
import Button from "@/components/basic/button/Button.vue"
import Bubble from "@/components/bubble/bubble.vue"
import IconButton from "@/components/basic/button/IconButton.vue"
import CreateEditEasy from "@/page/create/createEasyMode/createEditEasy.vue"
import ModeSwitch from "@/page/create/modeSwitch.vue"
import createGuidTour from "@/page/create/createGuid/createGuidTour.vue"
import { showActionDialog } from "@/components/functionCallComponent/action/action.js"

import useLyricDataStore from "@/store/create/lyricDataStore.js"
import useDraftDataStore from "@/store/create/draftDataStore.js"
import useFeedListStore from "@/store/create/feedListDataStore.js"
import useUserDataStore from "@/store/userDataStore.js"
import useMuseDataStore from "@/store/create/museDataStore.js"
import useDiverStore from "@/store/driverStore.js"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js"
import useGlobalUserStateStore from "@/store/globalUserStateStore.js"
import useModelDataStore from "@/store/model/modelDataStore.js"

const globalPlayDataStore = useGlobalPlayDataStore()
const driverStore = useDiverStore()
const createLayoutStore = useCreateLayoutStore()
const museDataStore = useMuseDataStore()
const globalUserStateStore = useGlobalUserStateStore()
const modelDataStore = useModelDataStore()
const draftDataStore = useDraftDataStore()
const lyricDataStore = useLyricDataStore()
const feedListDataStore = useFeedListStore()
const userDataStore = useUserDataStore()
const { curPlayData } = storeToRefs(globalPlayDataStore)

const { curDriverKey } = storeToRefs(driverStore)
const {
  createRenderType,
  create_createEditOpenState,
  nocreate_createEditOpenState,
  globalPlayerOpened,
  createEditMode,
  createEditGuidTourVisible,
  vocalCornerMarkVisible,
  createEditGuidTourControlVisible,
} = storeToRefs(createLayoutStore)

const { museLeadDataType, referenceData, motifData } = storeToRefs(museDataStore)

const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const refCreateEditMuse = ref(null)
const refCreateEditLyric = ref(null)
const refCreateSubmitButton = ref(null)
const refCreateEditAdvance = ref(null)
const refEditLyric = ref(null)

const props = defineProps({
  similarData: {
    type: Object,
    default: () => {
      return null
    },
  },
  renderType: {
    type: String,
    default: "create",
  },
  initClose: {
    type: Boolean,
    default: false,
  },
})
const emits = defineEmits([])
const renderData = reactive({
  disabled: false,
  userCredits: userDataStore.isLogin ? userDataStore.credits ?? 0 : 0,
  createTipText: "",
  isLoading: false,
  ifRender: true,
  editBoxHeight: "100%",
  refElList: [],
  createHasInit: false,
  curHighlightRefer: null,
  createEditMode: props.similarData ? "hard" : createLayoutStore.createEditMode,
  vocalCornerMarkReferHighlight: vocalCornerMarkVisible.value,
})

const closeCreateEdit = (e) => {
  e ??= window.event
  e.preventDefault()
  createLayoutStore.toggleCreateEditOpenState(false)
}

const openCreateEdit = () => {
  createLayoutStore.toggleCreateEditOpenState(true)
}

const pointCreateAdvancedModeCreate = (optimize) => {
  const feedData = draftDataStore.getGenerateDraftData()

  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext
    ?.config?.globalProperties
  globalProperties.logClickEvent("create_advanced_mode_create", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    tab_stare: createLayoutStore.createModeGuideTabState ? "guide_switch" : "switch",
    similar: props.similarData ? "true" : "false",
    control: feedData.museLeadDataType?.join(","),
    source: modelDataStore.current_model?.model,
    is_self:
      modelDataStore.current_model?.uid &&
      modelDataStore.current_model?.uid == userDataStore?.userInfo?.user?.user_id
        ? 1
        : 0,
    preset: feedData.motif?.source_type?.toString() ?? null,
    optimize: optimize?.toString(),
  })
}

const doGernerate = async (isInit) => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext
    ?.config?.globalProperties
  driverStore.setcurDriverKey("")
  if (
    !(await userDataStore.checkLoginStatus(
      {
        rightType: "generate", //"generate",
        create_type: "1",
        generate: "0",
      },
      (isLogin) => {
        if (isLogin) {
          performGenerate(true)
        }
        console.log("doGernerate_advanced")
        localStorage.removeItem(`${globalConfig.appname}_create_data`)
      }
    ))
  ) {
    localStorage.setItem(
      `${globalConfig.appname}_create_data`,
      JSON.stringify({
        type: "advanced",
        timeScamps: new Date().getTime(),
        lyrics: lyricDataStore.lyric,
        title: lyricDataStore.title,
      })
    )
    globalProperties.logClickEvent("newuser_create", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    })
    pointCreateAdvancedModeCreate()
    return
  }
  performGenerate(isInit)
}

const lyricsOptimizeDetect = () => {
  return new Promise((resolve) => {
    if (ModuleOpenStateControl.create.lyricsOptimize) {
      feedListApi
        .lyricsOptimizeDetect({
          lyrics: lyricDataStore.lyric,
        })
        .then((res) => {
          if (res.code == 200) {
            resolve(res.data)
          } else {
            resolve({
              need_popup_guidance: false,
              optimize_type: 0,
            })
          }
        })
        .catch(() => {
          resolve({
            need_popup_guidance: false,
            optimize_type: 0,
          })
        })
    } else {
      resolve({
        need_popup_guidance: false,
        optimize_type: 0,
      })
    }
  })
}

const performGenerate = async (isInit, isAlert = true) => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext
    ?.config?.globalProperties
  const model = modelDataStore.current_model
  if (
    modelDataStore.current_model?.need_credit_alert &&
    (modelDataStore.current_model?.free_to_use ?? 0) <= 0 &&
    isAlert &&
    !props.similarData
  ) {
    showActionDialog({
      content: !modelDataStore.current_model?.uid
        ? $$t("editor.o1_model_create_alert")
        : $$tValue("editor.user_model_create_alert", {
            credits: modelDataStore.current_model?.required_credits,
            songcount: 2,
          }),
      cancelLabel: $$t("create.cancel"),
      confirmLabel: $$t("create.create"),
      titleAlign: "left",
      close() {
        pointCreateAdvancedModeCreate()
      },
      confirm: (closeAction) => {
        closeAction()
        modelDataStore.changeCurrentModelAlertState(model, false)
        performGenerate(isInit, false)
      },
      cancel: (closeAction) => {
        closeAction?.()
        modelDataStore.changeCurrentModelAlertState(model, false)
        pointCreateAdvancedModeCreate()
      },
    })
  } else {
    if (!props.similarData) {
      if (!globalUserStateStore.setBasicModeClickedGuidVisible("easy")) {
        //  modelDataStore.showChooseModelPop();
      }
    }
    lyricsOptimizeDetect().then((res) => {
      if ([3, 4].includes(res.optimize_type)) {
        globalProperties.logCustomEvent("lyric_optimize_popup_show", {
          type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
        })
        if (res.need_popup_guidance) {
          createLayoutStore.setLyricOptimizeGuidVisibleCount(0)
        }
        showActionDialog({
          content: $$t("editor.lyric_optimize_alert"),
          cancelLabel: $$t("editor.lyric_optimize_alert_cancel"),
          confirmLabel: $$t("editor.lyric_optimize_alert_confirm"),
          titleAlign: "center",
          showCloseBtn: true,
          btnLayoutVerical: true,
          close: (closeAction) => {
            closeAction?.()
            globalProperties.logCustomEvent("lyric_optimize_popup_click", {
              type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
              tab_stare: "close",
            })
            pointCreateAdvancedModeCreate(res.optimize_type)
            createLayoutStore.toggleLyricOptimizeGuidVisible(true)
          },
          confirm: (closeAction) => {
            closeAction?.()
            doSseGenerate(isInit, res, 1)
            pointCreateAdvancedModeCreate(res.optimize_type)
            globalProperties.logCustomEvent("lyric_optimize_popup_click", {
              type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
              tab_stare: "optimize",
            })
            createLayoutStore.toggleLyricOptimizeGuidVisible(true)
          },
          cancel: (closeAction) => {
            closeAction?.()
            doSseGenerate(isInit, res, 0)
            pointCreateAdvancedModeCreate(res.optimize_type)
            globalProperties.logCustomEvent("lyric_optimize_popup_click", {
              type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
              tab_stare: "not_optimize",
            })
          },
        })
      } else {
        doSseGenerate(isInit, res, 0)
        pointCreateAdvancedModeCreate(res.optimize_type)
      }
    })
  }
}

const doSseGenerate = (isInit = false, lyricsOptimizeRes = {}, need_lyrics_optimize) => {
  renderData.isLoading = true
  feedListDataStore
    .doGernerate(
      isInit,
      {
        membership_source1: "create",
        membership_source2: props.similarData ? "create_advance_similar" : "create_advance",
        similarData: props.similarData,
        ...lyricsOptimizeRes,
        need_lyrics_optimize: need_lyrics_optimize,
      },
      {
        optimizedLyricsCallback: refEditLyric.value?.optimizedLyricsCallback,
      }
    )
    .then(() => {
      renderData.isLoading = false
      modelDataStore.changeFreeState(model)
      // setTimeout(() => {
      //   if (
      //     createLayoutStore.createEditMode != "easy" &&
      //     !props.similarData
      //   ) {
      //     globalUserStateStore.showBasicModeClickedGuidVisible("easy");
      //   }
      // }, 3000);
      if ([3, 4].includes(lyricsOptimizeRes.optimize_type) && !need_lyrics_optimize) {
        createLayoutStore.toggleLyricOptimizeGuidVisible(true)
      }
    })
    .catch((e) => {
      renderData.isLoading = false
      if ([3, 4].includes(lyricsOptimizeRes.optimize_type) && !need_lyrics_optimize) {
        createLayoutStore.toggleLyricOptimizeGuidVisible(true)
      }
    })
}

const switchCurOpModule = (key) => {
  createLayoutStore.setCurOpModule(key)
}
const goBuyCredits = () => {
  createLayoutStore.toggleCreateEditOpenState(false)
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router
  Router.push({
    name: "subscribe",
    query: {
      membership_source1: "create",
      membership_source2: props.similarData ? "create_advance_similar" : "create_advance",
    },
  })
}
const reRender = () => {
  renderData.ifRender = false
  nextTick(() => {
    renderData.ifRender = true
  })
}

watch(
  () => {
    return userDataStore.credits
  },
  () => {
    renderData.userCredits = userDataStore.credits ?? 0
  }
)

watch(
  () => {
    return lyricDataStore.lyric
  },
  () => {
    renderData.disabled = lyricDataStore.lyric.length < 1
  }
)

watch(
  () => {
    return userDataStore.isLogin
  },
  () => {
    renderData.userCredits = userDataStore.isLogin ? userDataStore.credits ?? 0 : 2

    if (userDataStore.isLogin) {
      // if (createEditMode.value == "hard") {
      //   userDataStore.getUesrRewardsShow()
      // }
      nextTick(() => {
        setTimeout(() => {
          initGenerate()
        }, 20)
      })
    }
  }
)

const rerenderLyric = () => {
  nextTick().then(() => {
    reRender()
  })
}

const setEditBoxHeight = () => {
  renderData.editBoxHeight = window.innerHeight + "px"
}

const initGenerate = () => {
  console.log("initGenerate_advanced")
  if (userDataStore.isLogin) {
    let _create_data = localStorage.getItem(`${globalConfig.appname}_create_data`)
    try {
      _create_data = JSON.parse(_create_data)
      if (_create_data) {
        if (new Date().getTime() - _create_data?.timeScamps < 1000 * 60 * 60) {
          if (_create_data.type == "advanced") {
            nextTick(() => {
              lyricDataStore.updateLyric(_create_data.lyrics)
              lyricDataStore.updateTitle(_create_data.title)
            }).then(() => {
              performGenerate(true)
              localStorage.removeItem(`${globalConfig.appname}_create_data`)
              createLayoutStore.toggleCreateEditOpenState(true)
              createLayoutStore.setCreateEditMode("hard")
            })
          }
        }
      } else {
        _create_data = null
        localStorage.removeItem(`${globalConfig.appname}_create_data`)
      }
    } catch (e) {
      _create_data = null
      localStorage.removeItem(`${globalConfig.appname}_create_data`)
    }
  } else {
    localStorage.removeItem(`${globalConfig.appname}_create_data`)
  }
}

const initPoint = () => {
  const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext
    ?.config?.globalProperties
  if (createRenderType.value == "pc") {
    if (renderData.createEditMode == "hard") {
      globalProperties?.logPageMounted("create_advanced_mode", {
        type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
        tab_stare: createLayoutStore.createModeGuideTabState ? "guide_switch" : "switch",
        source: modelDataStore.current_model?.model,
        is_self:
          modelDataStore.current_model?.uid &&
          modelDataStore.current_model?.uid == userDataStore?.userInfo?.user?.user_id
            ? 1
            : 0,
      })
    } else {
      globalProperties?.logPageMounted("create_basic_mode", {
        type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
        tab_stare: createLayoutStore.createModeGuideTabState ? "guide_switch" : "switch",
        source: modelDataStore.current_model?.model,
        is_self:
          modelDataStore.current_model?.uid &&
          modelDataStore.current_model?.uid == userDataStore?.userInfo?.user?.user_id
            ? 1
            : 0,
      })
    }
  } else {
    if (
      create_createEditOpenState.value == "max" ||
      create_createEditOpenState.value == "playermax"
    ) {
      if (renderData.createEditMode == "hard") {
        globalProperties?.logPageMounted("create_advanced_mode", {
          type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
          tab_stare: createLayoutStore.createModeGuideTabState ? "guide_switch" : "switch",
          source: modelDataStore.current_model?.model,
          is_self:
            modelDataStore.current_model?.uid &&
            modelDataStore.current_model?.uid == userDataStore?.userInfo?.user?.user_id
              ? 1
              : 0,
        })
      } else {
        globalProperties?.logPageMounted("create_basic_mode", {
          type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
          tab_stare: createLayoutStore.createModeGuideTabState ? "guide_switch" : "switch",
          source: modelDataStore.current_model?.model,
          is_self:
            modelDataStore.current_model?.uid &&
            modelDataStore.current_model?.uid == userDataStore?.userInfo?.user?.user_id
              ? 1
              : 0,
        })
      }
    }
  }
}

const debounceInitPoint = tools.debounce(initPoint, 1000)

watch(
  () => {
    return createEditMode.value
  },
  () => {
    if (!props.similarData) {
      renderData.createEditMode = createEditMode.value
    }
    // if (createEditMode.value == "hard" && userDataStore.isLogin) {
    //   userDataStore.getUesrRewardsShow()
    // }
  }
)

watch(
  () => {
    return renderData.createEditMode
  },
  () => {
    debounceInitPoint()
  }
)

watch(
  () => {
    return create_createEditOpenState.value
  },
  () => {
    debounceInitPoint()
  }
)

watch(
  () => {
    return createLayoutStore.curHighlightReferType
  },
  () => {
    renderData.curHighlightRefer = createLayoutStore.curHighlightReferType?.type
  }
)

const removeHighlight = () => {
  renderData.curHighlightRefer = null
  renderData.vocalCornerMarkReferHighlight = false
}

const changeRewardsShowState = () => {
  userDataStore.changeRewardsShowState()
}

onMounted(async () => {
  if (!props.similarData) {
    renderData.createEditMode = createLayoutStore.createEditMode
  }
  nextTick().then(() => {
    renderData.refElList = [
      refCreateEditLyric,
      refCreateEditMuse,
      createRenderType.value == "pc" ? refCreateEditAdvance : refCreateSubmitButton,
    ]
    if (userDataStore.isLogin) {
      initGenerate()
    }
  })
  renderData.disabled = lyricDataStore.lyric.length < 1
  initPoint()
  nextTick().then(() => {
    renderData.curHighlightRefer = createLayoutStore.curHighlightReferType?.type
    nextTick(() => {
      refCreateEditMuse.value?.querySelector(".reference-item--highlight")?.scrollIntoView()
    })
    // document.addEventListener("click", removeHighlight);
  })
  // globalProperties.logPageMounted("create", {
  //   mode: renderData.createEditMode == "hard" ? "2" : "1",
  // });

  // if (userDataStore.isLogin) {
  //   // userDataStore.refreshUserAccount()
  //   if (createEditMode.value == "hard") {
  //     userDataStore.getUesrRewardsShow()
  //   }
  // }

  // setEditBoxHeight();
  // $$registLanguageChangeListener(rerenderLyric);
})

onUnmounted(() => {
  // $$removeLanguageChangeListener(rerenderLyric);
  createLayoutStore.setCurHighlightReferType(null)
  // document.removeEventListener("click", removeHighlight);
})

defineExpose({
  openEdit() {},
  getOptimizedLyricsCallback() {
    return refEditLyric.value?.optimizedLyricsCallback
  },
})
</script>
<style lang="scss">
@keyframes create-refer-highlight-refer {
  0% {
    background: linear-gradient(180deg, rgba(115, 148, 255, 0.36) 0%, rgba(11, 36, 115, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
  50% {
    background: linear-gradient(180deg, rgba(115, 148, 255, 0.9) 0%, rgba(11, 36, 115, 0) 100%);
    // transform: scaleY(1.2);
    filter: brightness(1.5);
  }
  100% {
    background: linear-gradient(180deg, rgba(115, 148, 255, 0.36) 0%, rgba(11, 36, 115, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
}

@keyframes create-refer-highlight-vocal {
  0% {
    background: linear-gradient(180deg, rgba(212, 148, 255, 0.36) 0%, rgba(63, 13, 97, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
  50% {
    background: linear-gradient(180deg, rgba(212, 148, 255, 0.9) 0%, rgba(63, 13, 97, 0) 100%);
    // transform: scaleY(1.2);
    filter: brightness(1.5);
  }
  100% {
    background: linear-gradient(180deg, rgba(212, 148, 255, 0.36) 0%, rgba(63, 13, 97, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
}

@keyframes create-refer-highlight-prompt {
  0% {
    background: linear-gradient(180deg, rgba(81, 176, 220, 0.36) 0%, rgba(10, 69, 76, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
  50% {
    background: linear-gradient(180deg, rgba(81, 176, 220, 0.9) 0%, rgba(10, 69, 76, 0) 100%);
    // transform: scaleY(1.2);
    filter: brightness(1.5);
  }
  100% {
    background: linear-gradient(180deg, rgba(81, 176, 220, 0.36) 0%, rgba(10, 69, 76, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
}
@keyframes create-refer-highlight-motif {
  0% {
    background: linear-gradient(180deg, rgba(200, 115, 154, 0.36) 0%, rgba(67, 25, 12, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
  50% {
    background: linear-gradient(180deg, rgba(200, 115, 154, 0.9) 0%, rgba(67, 25, 12, 0) 100%);
    // transform: scaleY(1.2);
    filter: brightness(1.5);
  }
  100% {
    background: linear-gradient(180deg, rgba(200, 115, 154, 0.36) 0%, rgba(67, 25, 12, 0) 100%);
    // transform: scaleY(1);
    filter: brightness(1);
  }
}

.create-edit-content-box {
  height: 100%;
  overflow-y: scroll;
  min-width: max-content;
  .create-edit {
    display: flex;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    height: 100%;
    flex-direction: column;
    min-height: 400px;

    .create-edit-content {
      flex-direction: column;
    }
    .create-mode-switch-box {
      padding: 20px 20px 20px 0;
      justify-content: space-between;
      .create-edit-title-close {
        display: none;
      }
      .create-mode-switch {
        width: 0;
        flex: 1 1 0;
        max-width: 244px;
      }
      .model-box {
        margin: 0 0 0 8px;
      }
    }
    .create-edit-box {
      flex-direction: column;
      margin: 0 20px 20px 0;
    }
    .create-edit-area {
    }
    .create-edit-muse-area {
      margin: 0 0 0 0;
    }
    .create-edit-lyric {
      width: 300px;
      margin: 0 0 0 0;
      height: 100%;
      // transition: all 0.3s ease;
    }
    .create-edit-muse {
      height: 100%;
      width: 220px;
      margin: 0 0 0 12px;
      overflow-y: scroll;
      position: relative;
      // transition: all 0.3s;
      &.create-edit-muse-disabled {
        filter: grayscale(1);
      }
      .create-edit-muse-area-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      &.create-edit-muse-hide {
        width: 0;
        margin: 0 0 0 12px;
      }
    }
    .create-submit {
      position: relative;
      margin: 20px 0 0 0px;
      height: 48px;
      border-radius: 60px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      letter-spacing: 0.02em;
      color: #fff;
      border-radius: 50px;
      background: rgba(255, 255, 255, 0.1);
      padding: 0 0 0 10px;
      justify-content: space-between;
      display: flex;
      align-items: center;

      .reward-popup {
        position: absolute;
        top: 4px;
        left: 0;
        transform: translateY(-100%);
        background: linear-gradient(109deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
        padding: 10px 32px 10px 12px;
        width: 164px;
        border-radius: 12px;
        color: #3d3d3d;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        &::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #fff7ce;
        }
        img {
          position: absolute;
          top: 10px;
          right: 12px;
          width: 14px;
          height: 14px;
        }
      }
      .btn-content {
        position: relative;
      }
      .create-submit-button-model-use-first {
        position: absolute;
        top: -8px;
        left: 110%;
        height: 22px;
        padding: 0 8px 0 8px;
        border-radius: 16px 20px 20px 0px;
        /* 自动布局 */
        display: flex;
        flex-direction: column;
        background: linear-gradient(112deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
        line-height: 22px;
        font-family: HarmonyOS Sans SC;
        font-size: 10px;
        font-weight: 400;
        color: #000;
      }
      .el-button {
        .el-icon.is-loading {
          background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
        }
      }
      .create-submit-credits {
        max-width: calc(100% - 150px);
        width: max-content;
        text-align: left;
        padding: 0 6px 0 4px;
        .credits-ico {
          height: 16px;
          width: 16px;
          background-image: url("@/assets/img/database-ico.png");
          background-size: 100% 100%;
        }
        .arrow-ico {
          height: 16px;
          width: 16px;
          background-image: url("@/assets/img/arrow-right-ico.png");
          background-size: 100% 100%;
        }
        span {
          margin: 0 4px;
        }
        &:hover {
          color: #94adff;
        }
        .create-submit-button-model-use-first-label {
          font-family: HarmonyOS Sans SC;
          font-size: 16px;
          font-weight: normal;
          line-height: normal;
          letter-spacing: 0.02em;
          background: linear-gradient(106deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
      }
      .create-submit-button {
        width: 150px;
        position: relative;
      }
    }

    .create-ai-identification {
      margin: 12px 0 0 0;
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.5);
      text-transform: capitalize;
      text-align: left;
    }

    .create-edit-area {
      padding: 0 0 0 0;
    }

    .create-title {
      margin: 0px 0 20px 0;
      font-family: HarmonyOS Sans SC;
      font-size: 0px;
      font-weight: 500;
      line-height: 0px;
      height: 0;
      color: #ffffff;
      display: none;
    }
    .create-edit-lyric-area {
      height: 100%;
    }
    .reference-item {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      &.reference-item--highlight {
        &.reference-item-refer {
          .reference-empty,
          .reference-not-empty {
            // animation: create-refer-highlight-refer 5s 0.1s 20;
            // animation-timing-function: cubic-bezier(0.48, 0.23, 0.48, 0.76);
            background: linear-gradient(
              180deg,
              rgba(115, 148, 255, 1) 0%,
              rgba(11, 36, 115, 0) 100%
            );
            filter: brightness(1.3);
          }
        }
        &.reference-item-vocal {
          .reference-empty,
          .reference-not-empty {
            // animation: create-refer-highlight-vocal 5s 0.1s 20;
            // animation-timing-function: cubic-bezier(0.48, 0.23, 0.48, 0.76);
            background: linear-gradient(180deg, rgb(184 117 250) 0%, rgba(63, 13, 97, 0) 100%);
            filter: brightness(1.3);
          }
        }
        &.reference-item-prompt {
          .reference-empty,
          .reference-not-empty {
            // animation: create-refer-highlight-prompt 5s 0.1s 20;
            // animation-timing-function: cubic-bezier(0.48, 0.23, 0.48, 0.76);
            background: linear-gradient(180deg, rgba(81, 176, 220, 1) 0%, rgba(10, 69, 76, 0) 100%);
            filter: brightness(1.3);
          }
        }
        &.reference-item-motif {
          .reference-empty,
          .reference-not-empty {
            background: linear-gradient(
              180deg,
              rgba(200, 115, 154, 1) 0%,
              rgba(67, 25, 12, 0) 100%
            );
            filter: brightness(1.3);
            // animation: create-refer-highlight-motif 5s 0.1s 20;
            // animation-timing-function: cubic-bezier(0.48, 0.23, 0.48, 0.76);
          }
        }
      }
      &.reference-item--greydown {
        opacity: 0.75;
      }
      &.reference-item--gray-down {
        opacity: 0.5;
        .reference-title {
          opacity: 0.75;
        }
      }
      &.reference-item--highlight-new,
      &.reference-item--highlight-new-highlight-cur {
        &.reference-item-vocal {
          .reference-empty,
          .reference-not-empty {
            // animation: create-refer-highlight-vocal 5s 0.1s 20;
            // animation-timing-function: cubic-bezier(0.48, 0.23, 0.48, 0.76);
            background: linear-gradient(180deg, rgb(184 117 250) 0%, rgba(63, 13, 97, 0) 100%);
            filter: brightness(1.3);
          }
          .reference-info {
            opacity: 1;
          }
        }
      }
      &.reference-item--highlight-new-highlight {
        opacity: 1;
        .reference-title {
          opacity: 1;
        }
        &.reference-item-vocal {
          &.reference-item-vocal {
            .reference-empty,
            .reference-not-empty {
              // animation: create-refer-highlight-vocal 5s 0.1s 20;
              // animation-timing-function: cubic-bezier(0.48, 0.23, 0.48, 0.76);
              filter: brightness(1);
            }
          }
          .reference-info {
            opacity: 1;
          }
        }
      }
    }
    .reference-item-text {
      height: 88px;
      border-radius: 12px;
      padding: 35px 20px;
      background: rgba(255, 255, 255, 0.05);
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.2);
    }

    .create-edit-easy {
      display: block;
      width: 300px;
      height: 100%;
      padding: 0px 0 0px 0;
      // transition: all 0.3s ease;
    }
    &.create-edit--easy {
      .create-edit-lyric {
        display: none;
      }
      .create-edit-easy {
        display: block;
        width: 400px;
      }
      .create-edit-box {
        margin: 0 8px 20px 0;
      }
      .create-edit-muse {
        width: 0;
        margin: 0 0 0 12px;
      }
      .create-submit {
        display: none;
      }
    }
    &.create-edit--hard {
      width: 553px;
      .create-edit-lyric {
        display: block;
      }
      .create-edit-easy {
        display: none;
      }
    }
  }
  .create-result {
    height: 100%;
  }
  .create-edit-title {
    padding: 0px 0 0 0;
    .create-edit-title-close {
      display: none;
    }
  }

  .create-min-button-box {
    position: absolute;
    bottom: 60px;
    left: 16px;
    right: 16px;
    height: 48;
    z-index: 2;
    // transition: display 0.3s ease;
    display: none;

    .create-submit-button-model-use-first {
      position: absolute;
      top: -8px;
      left: 105%;
    }
    .create-min-button {
      width: 100%;
      height: 100%;
      background-image: url("@/assets/img/create-btn-bg.png");
      background-size: 100% 100%;
      border-radius: 48;
      line-height: 48;
      text-align: center;
      i {
        width: 20px;
        height: 20px;
        background-image: url("@/assets/img/music-ico-white.png");
        background-size: 100% 100%;
      }
      span {
        font-family: HarmonyOS Sans SC;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        color: #ffffff;
        margin-left: 5px;
      }
    }
  }
  .create-min-button-player-box {
    display: none;
    .create-min-button-player-player {
      height: 56px;
    }
    .create-min-button-player-button {
      height: 56px;
      width: 56px;
      background-image: url("@/assets/img/create-btn-bg.png");
      background-size: 100% 100%;
      border-radius: 48px;
      i {
        width: 24px;
        height: 24px;
        background-image: url("@/assets/img/music-ico-white.png");
        background-size: 100% 100%;
      }
    }
  }
  /*.create-edit-muse-area--disabled {
    opacity: 0.5;
    .reference-empty {
      opacity: 1;
      background: rgba(255, 255, 255, 0.1);
      .reference-title {
        opacity: 0.5;
      }
      .reference-info {
        opacity: 0.5;
      }
      .reference-icon i {
        opacity: 0.5 !important;
      }
    }
  }*/
}
.create-edit-content-box.create-edit-content-box--mobile {
  // position: fixed;
  // z-index: 10;
  // top: 0;
  // left: 0;
  height: 100%;
  width: 100%;
  min-height: 100%;
  // transition: all 0.3s ease;
  // background: rgba(71, 74, 74, 0.5);
  // backdrop-filter: blur(100px);
  overflow-y: unset;
  min-width: unset;
  .create-edit {
    height: 100%;
    flex-direction: column;
    width: 100%;
    border-right: none;
    height: 100%;

    .create-edit-box {
      flex-direction: column;
      margin: 0 0px 0px 0;
    }
    .create-edit-area {
      overflow-y: scroll;
    }

    .create-title {
      display: none;
    }
    .create-edit-lyric-area {
      height: 100%;
    }
    .create-mode-switch-box {
      padding: 0px 0 16px 0;
      .create-edit-title-close {
        display: none;
      }
      .model-box {
        flex-shrink: 0;
        width: 56px;
        margin: 0 8px;
      }
    }
    &.create-edit--easy {
      .create-edit-lyric {
        display: none;
        margin: 0 0;
      }
      .create-edit-easy {
        display: block;
        width: 100%;
        margin: 0 0;
      }
      .create-edit-muse {
        display: none;
      }
      .create-submit {
        display: none;
      }
    }
    &.create-edit--hard {
      .create-edit-lyric {
        display: block;
        margin: 0 0;
      }
      .create-edit-easy {
        display: none;
        margin: 0 0;
      }
    }
  }
  .create-edit-content {
    // background-image: url(/src/assets/img/main-bg-mobile-wp.webp);
    background-size: 100% 100%;
    padding: 0 16px;
  }
  .create-edit-title {
    display: flex;
    font-family: HarmonyOS Sans SC;
    font-size: 24px;
    line-height: 40px;
    height: 0;
    font-weight: 500;
    color: #ffffff;
    padding: 0px 0 0 0;
    align-items: center;
    .create-edit-title-close {
      display: block;
    }
  }

  .create-edit-area {
    flex-direction: column;
    height: unset;
    .create-edit-lyric {
      height: 0;
      min-height: 350px;
      width: 100%;
    }
    .create-edit-muse {
      height: unset;
      width: 100%;
      margin: 12px 0 0 0;
      display: flex;
      overflow-y: unset;
      min-height: 106px;
    }
    .create-edit-muse-area {
      width: 100%;
      height: unset;
      display: block;
      margin: 0 0 0 0;

      .reference-item {
        flex: 1;
        margin: 0;
        margin: 12px 0 0 0;
      }
      .reference-item:first-child {
        margin: 0;
      }
      .reference-item:last-child {
        margin: 12px 0 6px 0;
      }
    }
    .reference-item-motif,
    .reference-item-vocal,
    .reference-item-feature {
      display: block;
    }
    .reference-item-text {
      height: 80px;
      border-radius: 12px;
      padding: 31px 20px;
      background: rgba(255, 255, 255, 0.05);
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.2);
    }
  }
  .create-submit {
    padding: 10px 16px 0px 16px;
    margin: 0;
    background: linear-gradient(180deg, rgba(5, 16, 47, 0) 0%, #05102f 52%);
    margin: 0 -16px;
    border-radius: 0;
    height: max-content;
    .create-ai-identification {
      margin: 12px 0 -10px 0;
      text-align: center;
    }
    .create-submit-button {
      border-radius: 48px;
    }
    .create-submit-credits {
      display: none;
    }
    .el-button {
      background-image: url("@/assets/img/create-btn-bg.png");
      background-size: 100% 100%;
    }
    .create-submit-button {
      width: 100%;
      span.ico {
        width: 24px;
        height: 24px;
        background-image: url("@/assets/img/music-ico-white.png");
        background-size: 100% 100%;
        margin-right: 10px;
      }
    }
  }

  .create-edit-area {
    padding: 0 0 0 0;
  }
  &.create-edit--open {
    transform: translateY(0);
    .create-min-button-box {
      display: none;
    }
  }
  &.create-edit--min {
    // transform: translateY(100%);
    .create-min-button-box {
      display: block;
    }
    .create-min-button {
      display: block;
    }
    .create-min-button-player-box {
      display: none;
    }
  }
  &.create-edit--playerMin {
    //  transform: translateY(100%);
    .create-min-button-box {
      display: block;
    }
    .create-min-button {
      display: none;
    }
    .create-min-button-player-box {
      display: flex;
    }
  }
}
.main-page-bottom-player-visible--true {
  &.main-page--pc {
    .create-edit-content-box {
      padding-bottom: 64px;
    }
    .mescroll:after {
      content: "";
      display: block;
      width: 100%;
      height: 64px;
    }
    .create-edit {
      .mescroll:after {
        content: "";
        display: block;
        width: 100%;
        height: 0;
      }
    }
  }
  &.main-page--mobile {
    .mescroll:after {
      content: "";
      display: block;
      width: 100%;
      height: 80px;
    }
    .create-edit-ideas-items {
      .mescroll:after {
        content: "";
        height: 0;
      }
    }
  }
}
.main-page-bottom-player-visible--false {
  &.main-page--mobile {
    .mescroll:after {
      content: "";
      display: block;
      width: 100%;
      height: 0;
    }
    .create-edit {
      .mescroll:after {
        content: "";
        display: block;
        width: 100%;
        height: 0;
      }
    }
  }
}
</style>
